import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { styled } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import { ConvertEpochToDate } from '@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date';
import { useTranslation } from "react-i18next";


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    tableRow: {
        backgroundColor: '#1F4A7C',
        color: '#fff'
    },
    tableCell: {
        backgroundColor: '#f2f2f2',
        padding: '10px',
        fontWeight: 'bold',
        border: '1px solid #ddd',
    },
    blueText: {
        color: '#1F4A7C',
    },
});

const headerData = [
    { slno: "Sl. No" },
    { name: "Name" },
    // { email: 'Email'  },   
    { mobileNo: "Mobile No" },
    { servicetype: "Service Type" },
    { applicationNo: "Application No" },
    { District: "District" },
    // { area: 'Notified-Area / ULB'  },
    { Status: "Status" },
    { ApplicationFee: "Application Fee"},
    { dos: "Date Of Submission" },
    // { Address: "Address" },
];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#1f4a7c",
        color: theme.palette.common.white,
        fontSize: 16
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));
const InboxTable = ({ apiData }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = React.useState(0);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <Paper sx={{ overflow: "hidden", marginY: 2 }}>
            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            {headerData.map((item) => (
                                <TableCell key={Object.values(item)[0]}>
                                    {Object.values(item)[0]}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ backgroundColor: '#fbfaff' }}>
                        {apiData && apiData?.MISReportDetails
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>
                                    <StyledTableCell>{row?.ownerInfo?.[0]?.name}</StyledTableCell>
                                    {/* <StyledTableCell>{row?.ownerInfo?.[0]?.emailId}</StyledTableCell> */}
                                    <StyledTableCell>{row?.ownerInfo?.[0]?.mobileNumber}</StyledTableCell>
                                    <StyledTableCell>{row?.servicetype}</StyledTableCell>
                                    <StyledTableCell>{row?.applicationnumber}</StyledTableCell>
                                    <StyledTableCell>{row?.district}</StyledTableCell>
                                    {/* <StyledTableCell>{row?.area}</StyledTableCell> */}
                                    <StyledTableCell> {t(`${row?.status}`)}</StyledTableCell>
                                    <StyledTableCell>{row?.applicationFee}</StyledTableCell>
                                   <StyledTableCell> {ConvertEpochToDate(Number(row?.dateofSubmisson))}</StyledTableCell>
                                    {/* <StyledTableCell>{row?.ownerInfo?.[0]?.permanentAddress?.address}</StyledTableCell> */}
                                </StyledTableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 50, 75, 100]}
                component="div"
                count={apiData?.MISReportDetails?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

export default InboxTable;
